import React from 'react';
import { getPlatform } from '../../constants/platforms';
import PlatformLogo from '../ui/PlatformLogo';

export default function PlatformBadge({
  platformId = 'amazon',
  size = 'sm',
  showStatus = false,
  showLabel = true,
}) {
  const platform = getPlatform(platformId);
  const isComingSoon = platform.status === 'coming_soon';

  const sizeClasses = size === 'lg'
    ? 'px-3 py-1 text-sm'
    : 'px-2 py-0.5 text-xs';
  const logoSize = size === 'lg' ? 18 : platformId === 'amazon' ? 20 : 14;

  return (
    <span
      className={`inline-flex items-center max-w-full overflow-visible ${
        showLabel ? `gap-1.5 rounded-full font-medium ${sizeClasses}` : ''
      } ${
        showLabel
          ? isComingSoon
            ? 'bg-slate-100 text-slate-600 border border-slate-200'
            : 'bg-white text-slate-800 border border-slate-200'
          : ''
      }`}
    >
      {platform.logo ? (
        <PlatformLogo
          platformId={platformId}
          size={logoSize}
          variant={platformId === 'amazon' ? 'wordmark' : 'mark'}
        />
      ) : (
        <span
          className="w-2 h-2 rounded-full shrink-0"
          style={{ backgroundColor: isComingSoon ? '#94a3b8' : platform.brandColor }}
        />
      )}
      {showLabel ? (
        <span className="truncate max-w-[7rem]">{platform.shortName}</span>
      ) : null}
      {showStatus && isComingSoon && (
        <span className="text-[10px] uppercase tracking-wide opacity-70">Soon</span>
      )}
    </span>
  );
}
